<!-- 入力テキストフィールドコンポーネント -->
<template>
  <Field
    :name="name"
    :label="label"
    :model-value="modelValue ?? ''"
    :rules="rules"
    :validate-on-input="validateOnInput"
    v-slot="{ field, errors }"
  >
    <input
      :name="field.name"
      :data-testid="field.name"
      :type="type"
      :class="['input-text', inputClass, $attrs.class, { 'is-error': errors && errors.length > 0 }]"
      :placeholder="placeholder"
      :disabled="disabled"
      :maxlength="maxlength"
      :value="field.value ?? ''"
      @input="onFieldInput($event, field)"
      @blur="onFieldBlur($event, field)"
      autocomplete="off"
    />
  </Field>
</template>

<script setup lang="ts">
import { Field } from 'vee-validate'

const props = defineProps<{
  name: string
  label?: string
  modelValue?: string
  rules?: string | Record<string, unknown>
  type?: 'text' | 'email' | 'password' | 'number'
  placeholder?: string
  disabled?: boolean
  maxlength?: number
  inputClass?: string | string[] | Record<string, boolean>
  validateOnInput?: boolean
}>()

const validateOnInput = props.validateOnInput ?? true

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'blur'): void
}>()

function onFieldInput(e: Event, field: any) {
  const v = (e.target as HTMLInputElement).value
  if (field.onChange) {
    field.onChange(v)
  } else {
    field.onInput?.(e)
  }
  emit('update:modelValue', v)
}

function onFieldBlur(e: FocusEvent, field: any) {
  field.onBlur?.(e)
  emit('blur')
}
</script>
